import { Button } from '../Button/Button'
import React from 'react'
import { resetCustomEmailFilter, selectEmailFilterCount, setShowEmailFilterModal } from '../../store/emailHub/emailFilters'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../store/hooks'
import { useFetchEmailThreads } from '../../views/EmailV2/hooks'

export const EmailFilterButtons = () => {
  const dispatch = useDispatch()

  const filterCount = useAppSelector(selectEmailFilterCount)

  const { fetchEmailThreads } = useFetchEmailThreads()

  const resetFilter = async () => {
    dispatch(resetCustomEmailFilter())
    await fetchEmailThreads()
  }

  const showEmailFilterModal = () => {
    dispatch(setShowEmailFilterModal(true))
  }

  return (
    <div className='d-flex h-100 align-items-end'>
      <div className='d-flex align-items-center zocks-gap-0.75'>
        <Button
          variant='darkGhost'
          className='email-filter-button d-flex gap-1 p-2 paragraph-medium zocks-border-color-gray-500'
          onClick={showEmailFilterModal}
        >
          <i className='bi bi-funnel' />
          <div className='d-lg-none paragraph-small'>All filters</div>
          <div className='email-filter-count lead-small d-flex align-items-center justify-content-center zocks-border-0.125 zocks-bg-color-gray-900 zocks-text-white'>
            {filterCount}
          </div>
        </Button>
        <div className='d-none d-lg-flex gap-1 cursor-pointer' onClick={resetFilter}>
          <i className='bi bi-arrow-clockwise' />
          <div className='button-link-medium text-nowrap'>Clear all</div>
        </div>
      </div>
    </div>
  )
}
